import { useEffect } from "react";
import { useGetSupportChatTokenQuery } from "@/store/rest_api";
import { HUBSPOT_PORTAL_ID } from "@/components/provider/HubSpotChatLoader";

export function HubSpotChatIdentity() {
  const { data: chatIdentity } = useGetSupportChatTokenQuery(undefined, { skip: !HUBSPOT_PORTAL_ID });

  useEffect(() => {
    if (!chatIdentity) {
      return;
    }

    window.hsConversationsSettings = {
      ...window.hsConversationsSettings,
      identificationEmail: chatIdentity.email,
      identificationToken: chatIdentity.token,
    };

    const applyIdentity = () => {
      window.HubSpotConversations?.clear({ resetWidget: true });
    };

    if (window.HubSpotConversations) {
      applyIdentity();
    } else {
      window.hsConversationsOnReady = [...(window.hsConversationsOnReady ?? []), applyIdentity];
    }
  }, [chatIdentity]);

  return null;
}
